// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3pEk-","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1cImQ"};